import { css } from 'styled-components';
import token from 'styled-token';
import { StyledCheckbox } from '../../components/Checkbox/Checkbox.styles';
import { disabledCursorMixin } from '../disabledCursorMixin';
import { disabledOpacityMixin } from '../disabledOpacityMixin';
var backgroundImageOn = token('Switch.iconColorOn', function (fill) {
  return encodeURIComponent("<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.35714 13.8571L14.7857 6.84286C15.0671 6.54775 15.0703 6.0846 14.7929 5.78572C14.5143 5.50877 14.0643 5.50877 13.7857 5.78572L7.85714 12.2786L5.86429 10.0357C5.58569 9.75877 5.13574 9.75877 4.85714 10.0357C4.57775 10.3327 4.57775 10.7959 4.85714 11.0929L7.32857 13.8571C7.4632 13.9968 7.64886 14.0757 7.84286 14.0757C8.03686 14.0757 8.22251 13.9968 8.35714 13.8571Z\" fill=\"" + fill + "\"/></svg>");
});
var backgroundImageOff = token('Switch.iconColorOff', function (fill) {
  return encodeURIComponent("<svg width=\"20\" height=\"20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.2899 13.5714C14.2899 13.381 14.2138 13.1984 14.0786 13.0643L11.0071 10L14.0786 6.93571C14.3587 6.65563 14.3587 6.20152 14.0786 5.92143C13.7985 5.64134 13.3444 5.64134 13.0643 5.92143L10 8.99286L6.93571 5.92143C6.65563 5.64134 6.20152 5.64134 5.92143 5.92143C5.64134 6.20152 5.64134 6.65563 5.92143 6.93571L8.99286 10L5.92143 13.0643C5.78621 13.1984 5.71014 13.381 5.71014 13.5714C5.71014 13.7619 5.78621 13.9445 5.92143 14.0786C6.05555 14.2138 6.23812 14.2899 6.42857 14.2899C6.61903 14.2899 6.8016 14.2138 6.93571 14.0786L10 11.0071L13.0643 14.0786C13.1984 14.2138 13.381 14.2899 13.5714 14.2899C13.7619 14.2899 13.9445 14.2138 14.0786 14.0786C14.2138 13.9445 14.2899 13.7619 14.2899 13.5714Z\" fill=\"" + fill + "\"/></svg>");
});
var sizeCSS = function sizeCSS(props) {
  var size = props.size;
  return token({
    height: "Switch.sizes." + size + ".height",
    width: "Switch.sizes." + size + ".width",
    padding: "Switch.sizes." + size + ".padding"
  }, function (_ref) {
    var height = _ref.height,
      width = _ref.width,
      padding = _ref.padding;
    var iconSize = height - 2 * padding;
    return css(["height:", "px;width:", "px;border-radius:", "px;&:before{top:", "px;left:", "px;height:", "px;width:", "px;background-size:", "px;}", ":checked + &:before{left:", "px;}"], height, width, height, padding, padding, iconSize, iconSize, iconSize, StyledCheckbox, width - iconSize - padding);
  })(props);
};
var switchCSS = function switchCSS(props) {
  return token({
    backgroundColor: 'Switch.backgroundColor',
    backgroundColorChecked: 'Switch.backgroundColorChecked',
    backgroundColorHover: 'Switch.backgroundColorHover',
    backgroundColorCheckedHover: 'Switch.backgroundColorCheckedHover',
    borderColor: 'Switch.borderColor',
    borderColorHover: 'Switch.borderColorHover',
    borderRadius: 'Switch.borderRadius',
    focusBoxShadow: 'Switch.focusBoxShadow',
    iconBackgroundColorOn: 'Switch.iconBackgroundColorOn',
    iconBackgroundColorOff: 'Switch.iconBackgroundColorOff',
    transition: 'Switch.transition'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      backgroundColorChecked = _ref2.backgroundColorChecked,
      backgroundColorHover = _ref2.backgroundColorHover,
      backgroundColorCheckedHover = _ref2.backgroundColorCheckedHover,
      borderColor = _ref2.borderColor,
      borderColorHover = _ref2.borderColorHover,
      focusBoxShadow = _ref2.focusBoxShadow,
      iconBackgroundColorOn = _ref2.iconBackgroundColorOn,
      iconBackgroundColorOff = _ref2.iconBackgroundColorOff,
      transition = _ref2.transition,
      _ref2$borderRadius = _ref2.borderRadius,
      borderRadius = _ref2$borderRadius === void 0 ? '50%' : _ref2$borderRadius;
    return css(["display:inline-block;user-select:none;cursor:pointer;background-color:", ";border:1px solid ", ";&[aria-disabled='true']{", "}&:not([aria-disabled='true']):hover{background-color:", ";border-color:", ";}&,&:before{transition:", ";}position:relative;&:before{content:'';position:absolute;border-radius:", ";background-color:", ";background-image:url('data:image/svg+xml,", "');}", ":checked + &{background-color:", ";}", ":checked + &:not([aria-disabled=\"true\"]):hover{background-color:", ";border-color:", ";}", ":checked + &[aria-disabled=\"true\"]{", "}", ":checked + &:before{content:'';background-color:", ";background-image:url('data:image/svg+xml,", "');}", ":not(:checked) + &[aria-disabled=\"true\"]:before{", "}", ":focus-visible + &{box-shadow:", ";}@supports not selector(:focus-visible){", ":focus + &{box-shadow:", ";}}", ""], backgroundColor, borderColor, disabledCursorMixin(Object.assign({}, props, {
      disabled: true
    })), backgroundColorHover, borderColorHover, transition, borderRadius, iconBackgroundColorOff, backgroundImageOff(props), StyledCheckbox, backgroundColorChecked, StyledCheckbox, backgroundColorCheckedHover, borderColor, StyledCheckbox, disabledOpacityMixin(Object.assign({}, props, {
      disabled: true
    })), StyledCheckbox, iconBackgroundColorOn, backgroundImageOn(props), StyledCheckbox, disabledOpacityMixin(Object.assign({}, props, {
      disabled: true
    })), StyledCheckbox, focusBoxShadow, StyledCheckbox, focusBoxShadow, sizeCSS(props));
  })(props);
};
var zsgCompatCSS = function zsgCompatCSS(props) {
  return token({
    iconBackgroundColorOn: 'Switch.iconBackgroundColorOn',
    iconBackgroundColorOff: 'Switch.iconBackgroundColorOff',
    transition: 'Switch.transition'
  }, function (_ref3) {
    var iconBackgroundColorOn = _ref3.iconBackgroundColorOn,
      iconBackgroundColorOff = _ref3.iconBackgroundColorOff,
      transition = _ref3.transition;
    return css(["", " &&{", "}&&&:before{content:'';border:none;background-color:", ";transition:", ";box-shadow:none;}", ":checked + &&&:before{background-color:", ";}"], switchCSS(props), sizeCSS(props), iconBackgroundColorOff, transition, StyledCheckbox, iconBackgroundColorOn);
  })(props);
};

/** @class SwitchMixin */
/** @method */
export var SwitchMixin = process.env.NODE_ENV === 'test' ? switchCSS : zsgCompatCSS;